import { FC, ComponentProps } from 'react';
import { SFormikTextfield } from '@setvi/shared/components';

type EnhancerFormTextFieldProps = ComponentProps<typeof SFormikTextfield>;

export const EnhancerFormTextField: FC<EnhancerFormTextFieldProps> = props => (
  <SFormikTextfield
    {...props}
    InputProps={{
      ...(props.InputProps ?? {}),
      style: {
        ...(props.InputProps?.style ?? {}),
        backgroundColor: '#F8F9FA'
      }
    }}
  />
);
